<template>
  <div class="main-layout">
    <Head />
    <div class="layout-container">
      <SideMenu />
      <main class="main-content">
        <div class="content-view">
          <router-view v-slot="{ Component,route }">
            <keep-alive>
              <component :is="Component" :key="getCacheKey(route)" />
            </keep-alive>
          </router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import Head from '@/components/Head.vue'
import SideMenu from '@/components/SideMenu.vue'
import { useRouteCache } from '@/utils/useRouteCache'

const { getCacheKey } = useRouteCache()

</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f7fa;
}

.layout-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* 右侧内容区域 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 内容区域 */
.content-view {
  flex: 1;
  overflow: auto;
  background: #fff;
}

/* 滚动条样式 */
.content-view::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.content-view::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.3);
  border-radius: 3px;
}
</style>

